module Client.LocationInvoice


open Client
open Client.Services
open Shared
open global.Elmish
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.UseElmish
open Fable.Core.Experimental
open System.Text.RegularExpressions
// open Fable.Core.JS
let renderBreadcrumbs customerId invoiceNumberOption =
  let invoiceNumberLabel = match invoiceNumberOption with | None -> "Invoice" | Some name -> $"Invoice: %s{name}"
  Mui.breadcrumbs [
    breadcrumbs.children [
      Mui.link [
        prop.href (Client.Pages.toHash Pages.Page.Home)
        link.children "Home"
      ]
      Mui.link [
        prop.href (Client.Pages.toHash Pages.Page.Locations)
        link.children "Locations"
      ]
      Mui.link [
        prop.href (Client.Pages.toHash (Pages.Page.Location customerId))
        link.children "Location"
      ]
      Mui.typography [
        typography.color.textPrimary
        typography.children invoiceNumberLabel
      ]
    ]
  ]
let view = React.functionComponent (fun (inputProps: {| customerId : int; invoiceId : int; model : LoggedInModel; |}) ->
  let classes = Styles.useStyles ()
  let (invoice, setInvoice) = React.useState<Shared.AccountsReceivableInvoice option>(None)
  let (error, setError) = React.useState<string option>(None)
  let (isLoading, setIsLoading) = React.useState(true)

  React.useEffectOnce(fun () ->
    promise {
      let! authHeader = Services.getAuthHeader()
      try
        let decoder = Services.decoder<Result<Shared.AccountsReceivableInvoice,string>>
        let! response = Fetch.tryGet($"/api/Location/%i{inputProps.customerId}/Invoice/{inputProps.invoiceId}", headers = [ authHeader ], decoder = decoder)
        match response with
        | Ok v ->
          match v with
          | Ok invoiceData ->
            setInvoice (Some invoiceData)
          | Error msg ->
            setError (Some msg)
        | Result.Error fetchError ->
          match fetchError with
          | FetchError.DecodingFailed _ -> setError (Some "Problem parsing response")
          | FetchError.FetchFailed msg -> setError (Some "Problem fetching invoice")
          | FetchError.NetworkError _ -> setError (Some "Problem fetching invoice")
          | FetchError.PreparingRequestFailed _ -> setError (Some "Problem fetching invoice")
      with e ->
        setError (Some e.Message)
      setIsLoading false
    } |> ignore
  )

  Html.div [
    renderBreadcrumbs inputProps.customerId (invoice |> Option.map (fun x -> x.AccountsReceivableInvoiceHeader.InvoiceNumber))
    Html.h2 "Invoice"
    if isLoading then
      Mui.circularProgress []
    else
      match error with
      | Some msg -> Html.p [ prop.style [ style.color.red ]; prop.text msg ]
      | None ->
        match invoice with
        | None ->
          Html.p "Invoice not found"
        | Some x ->
          Mui.list [
            // prop.width 100
            list.children [
              // Conditionally render the PaymentLink
              match x.PaymentLink with
              | Some paymentLink ->
                Mui.listItem [
                  listItem.alignItems.flexStart
                  listItem.button true
                  listItem.component' "a"
                  prop.href paymentLink
                  prop.target "_blank" // Open in a new tab
                  prop.rel "noopener noreferrer" // Security best practice
                  listItem.children [
                    Mui.listItemText [
                      listItemText.primary x.AccountsReceivableInvoiceHeader.InvoiceNumber
                      listItemText.secondary "Click to pay invoice online"
                    ]
                  ]
                ]
              | None ->
                Mui.listItem [
                  listItem.alignItems.flexStart
                  // listItem.button true
                  // listItem.component' "a"
                  // prop.href (Client.Pages.toHash (Pages.Page.LocationEquipments customerId))
                  listItem.children [
                    Mui.listItemText [
                      listItemText.primary x.AccountsReceivableInvoiceHeader.InvoiceNumber
                      listItemText.secondary "No payment link available"
                    ]
                  ]
                ]
            ]
          ]
  ]
)
